import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class DownloadFileService {
  export(r: HttpResponse<Blob>, model: any) {
    const blob = r.body;
    var contentDisposition = r.headers.get('content-disposition');
    if (contentDisposition == null){
      const urlParams = new URLSearchParams(r.url);
      contentDisposition = urlParams.get('response-content-disposition').replace(/['"]+/g, '').replace(/\s/g, "") + ';';
    }
    model.url = window.URL.createObjectURL(blob);
    model['fileName'] = this.getFilenameFromContentDisposition(contentDisposition);
  }

  private getFilenameFromContentDisposition(contentDisposition: string): string {
    const regex = /filename=(?<filename>[^;]+);/g;
    const match = regex.exec(contentDisposition);
    const filename = match[1].replace(/^["_]+/, '').replace(/["_]+$/, '');
    return filename;
  }

  openExtract(url: string, model: any): void {
    const anchor = document.createElement('a');
    anchor.download = model['fileName'];
    anchor.href = url;
    anchor.target = '_blank';
    anchor.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 400);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/utilities/DownloadFileService.ts